// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2rLyb","label":"Section_label__2nPgh","contentWrap":"Section_contentWrap__xCe19","footer":"Section_footer__2sFqR","footerInner":"Section_footerInner__1YyRU"};